import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { register } from '@studio/entitlements';
import swUrl from '@studio/entitlements/service-worker?url';
import './main.css';
import '@appcues/sonar-tokens/dist/variables.css';
import '@typeform/embed/build/css/popup.css';
import '@studio/assistant/style.css';
import '@appcues/dashboards/style.css';

import { withProfiler } from '@sentry/react';
import { initializeAnalytics } from '@studio/analytics';

import App from './App';
import LoadingOverlay from './components/LoadingOverlay';

initializeAnalytics({
  commitHash: import.meta.env.COMMIT_HASH,
  environment: import.meta.env.APPCUES_ENV,
  isProd: import.meta.env.APPCUES_ENV === 'prod',
  providers: {
    logRocket: {
      enabled: import.meta.env.AWS_REGION !== 'eu-central-1',
      appId: 'rys1yn/appcues',
    },
    appcues: {
      enabled: true,
    },
    segment: {
      enabled: true,
      writeKey: import.meta.env.SEGMENT_WRITE_KEY,
    },
  },
});
register(swUrl);

const AppWithProfiler = withProfiler(() => (
  <React.StrictMode>
    <Suspense fallback={<LoadingOverlay />}>
      <App />
    </Suspense>
  </React.StrictMode>
));

const root = createRoot(document.querySelector('#root') as HTMLElement);
root.render(<AppWithProfiler />);
